/**
 * Mirrors packages/amgcarracing_v2/lib/core/constants/game_constants.dart
 * for endpoints, game keys, and the reference resolution used by the
 * Flutter web build.
 */
export const API_BASE = 'https://staginggameapi.tbgcablecar.xyz/api';

export const Endpoints = {
  login: `${API_BASE}/action/login`,
  openGame: `${API_BASE}/action/opengame`,
  checkBalance: `${API_BASE}/action/balance`,
  getInfo: `${API_BASE}/action/getinfo`,
  placeBet: `${API_BASE}/action/bet`,
  getHistory: `${API_BASE}/action/bethistory`,
} as const;

export const GAME_KEY_SINGLE = 'CAR1';
export const GAME_KEY_MULTI = 'CARM';
export const MULTIPLAYER_HUB_URL =
  'https://staginggameapi.tbgcablecar.xyz/carracehub';
export const DEFAULT_AGENT_ID = 'Agent1';

/** Reference stage size — mirrors apps/amg_carRacing_v2/web/index.html. */
export const REF_WIDTH = 1792;
export const REF_HEIGHT = 828;

/**
 * Hard-coded test credentials — match the Flutter LobbyScreen defaults
 * (packages/amgcarracing_v2/lib/presentation/screens/lobby_screen.dart).
 */
export const DEFAULT_USER_NAME = 'user2';
export const DEFAULT_PASSWORD = '123456';

/** Default game config — used until /action/getinfo overrides. */
export const DEFAULT_GAME_CONFIG = {
  minBet: 1,
  maxBet: 100000,
  chipValues: [1, 5, 10, 20, 50, 100] as const,
  gameOdds: [] as readonly number[],
};

/**
 * Spin-position mapping. Server returns the winning betItemId (370..377);
 * the Rive `Spin` Number input expects a final lap position 1..32.
 * Each betItemId has 4 possible spin positions — pick one at random.
 *
 * Mirrors CarRacingResultMappings.byBetItemId
 * (packages/amgcarracing_v2/lib/core/constants/game_constants.dart:37-48).
 */
export const SPIN_MAPPING: Record<number, readonly number[]> = {
  377: [5, 13, 21, 29], // GLamborghini
  376: [7, 15, 23, 31], // GFerrari
  375: [3, 11, 19, 27], // GBenz
  374: [1, 9, 17, 25], // GBmw
  373: [2, 10, 18, 26], // SLamborghini
  372: [6, 14, 22, 30], // SFerrari
  371: [8, 16, 24, 32], // SBenz
  370: [4, 12, 20, 28], // SBmw
};

/** ms — single-player `showResult` initial delay before first Spin write. */
export const SPIN_INITIAL_DELAY_SINGLE_MS = 2000;
/** ms — gap between Spin=0 (reset) and Spin=value. */
export const SPIN_RESET_GAP_MS = 100;
/** ms — after spinEnd, write Winning + result amount text. */
export const ENDING_ANIMATION_DELAY_MS = 1500;
/** ms — after ending animation step, clear Winning back to 0. */
export const WINNING_HIDE_DELAY_MS = 5000;
/** ms — safety net to finalize round after spinEnd. */
export const FINALIZE_AFTER_SPIN_END_MS = 6500;
/** ms — safety net to finalize single-player round after /action/bet returns. */
export const FINALIZE_AFTER_BET_SINGLE_MS = 10000;
/** ms — safety net to finalize multiplayer round after StartPlay. */
export const FINALIZE_AFTER_START_PLAY_MS = 12000;
